import AccountTree from '@material-ui/icons/AccountTree';
import Category from '@material-ui/icons/Category';
import People from '@material-ui/icons/People';
import Dns from '@material-ui/icons/Dns';

import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

interface Props {
  labelType: 'Audience' | 'Lifecycle' | 'Experience' | 'Type';
  value: string;
}

export const tooltipTitles: { [key: string]: { [key: string]: string } } = {
  Audience: {
    external: 'This component is exposed to users outside of Medidata.',
    internal: 'This component is not exposed to users outside of Medidata.',
  },
  Lifecycle: {
    deprecated:
      'A component that has reached the end of its lifecycle and has no active users or consumers.',
    experimental:
      'An experiment or early, non-production component, signaling that users may not prefer to consume it over other more established components, or that there are low or no reliability guarantees.',
    production: 'An established, owned, and maintained component.',
    sunsetting:
      'A component that is reaching the end of its lifecycle, and may disappear at a later point in time.',
  },
  Experience: {
    data: 'This component is part of the Data Experience.',
    study: 'This component is part of the Study Experience.',
    patient: 'This component is part of the Patient Experience.',
    enablement:
      'This component is part of the Enablement Experience. (Deprecated - please update to Platform, Operations, or Platform AI)',
    platform: 'This component is part of the Platform Experience.',
    operations: 'This component is part of the Operations Experience.',
    'platform-ai': 'This component is part of the Platform AI Experience.',
  },
  Type: {
    asyncapi: 'An API following asyncapi standards.',
    documentation: 'Documentation.',
    library:
      'A library that provides some useful functionality and can be referenced in other projects.',
    mobile: 'A mobile (or desktop) application.',
    openapi: 'An API following openapi standards.',
    service: 'A web service providing APIs to its consumers.',
    website: 'A frontend or website.',
  },
};

const avatars = {
  Audience: <People fontSize="small" />,
  Lifecycle: <Dns fontSize="small" />,
  Experience: <AccountTree fontSize="small" />,
  Type: <Category fontSize="small" />,
};

export const EntityLabel = (props: Props) => {
  const { labelType, value } = props;

  return (
    <Tooltip
      title={`${labelType}: ${value} - ${tooltipTitles[labelType][value]}`}
      arrow
    >
      <Chip
        key={labelType}
        size="small"
        label={value}
        avatar={avatars[labelType]}
        sx={{ paddingLeft: '3pt' }}
      />
    </Tooltip>
  );
};
